import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import BreadCrumb from '../../../../components/BreadCrumb';
import { getDecimalToHundredScale } from '../../../../services/util';
import ControlWithLabel from '../../components/StyledControlWithLabel';
import style from './index.scss';
import ScoringPanel from './ScoringPanel';
import { convertISOToDateFormat } from '../../../../util/timezone';
import { ALERT_REASON } from '../../../constants/crsContants';

/**
 * BackText
 * @type {string}
 */
const backText = '< Back';

const LOW_RISK_SCORE_THRESHOLD = 50;
const HIGH_RISK_SCORE_THRESHOLD = 85;

export const fillColorForPredictionLevel = (customerRiskScore) => {
  if (customerRiskScore >= HIGH_RISK_SCORE_THRESHOLD) return 'red';
  if (customerRiskScore <= LOW_RISK_SCORE_THRESHOLD) return 'green';
  if (
    customerRiskScore < HIGH_RISK_SCORE_THRESHOLD &&
    customerRiskScore > LOW_RISK_SCORE_THRESHOLD
  )
    return 'orange';
  return 'green';
};

/**
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const CRSDetailHeader = ({
  customerProfileData,
  isEmbedded,
  alertId,
  alertMetaSuffix,
  alertMetaPrefix,
  alertDetails
}) => {
  const {
    customerRiskScore = '0.00',
    fetched,
    isFetching
  } = customerProfileData || {};
  const riskScore = getDecimalToHundredScale(customerRiskScore);
  const { data = null } = alertDetails;
  return (
    <div className={style.container}>
      {/*<div className={style.backLink}>
        <div
          onClick={() => {
            history.back();
          }}
        >
          {" "}
          {backText}
        </div>
      </div>*/}
      {!isEmbedded && (
        <div className={style.breadcrumb}>
          <BreadCrumb
            crumbs={[
              { label: 'Customer List', linkTo: '/app/crs/customers' },
              { label: 'Customer Details' }
            ]}
          />
        </div>
      )}
      <div className={style.scoringPanel}>
        {isFetching && (
          <div className={style.ratingBar}>
            <div className={classnames(style.ratingBarTitle, style.loading)}>
              Fetching Risk Score...
            </div>
          </div>
        )}
        {!isFetching && !fetched && (
          <div className={style.ratingBar}>
            <div className={classnames(style.ratingBarTitle)}>
              Unable to fetch Risk Score...
            </div>
          </div>
        )}
        {/*fetched && (
          <div className={style.ratingBar}>
            <div className={style.circularRatingBar}>
              <SemiCircularBar
                value={riskScore}
                color={fillColorForPredictionLevel(riskScore)}
                thickness={10}
                min={0}
                max={100}
                text="Score"
                showMin
                showMax
                showText
              />
            </div>
            <div className={style.ratingBarTitle}>Customer Risk Score</div>
          </div>
        ) */}
        {fetched && (
          <ScoringPanel
            data={customerProfileData}
            fillColorForPredictionLevel={fillColorForPredictionLevel}
            lowThreshold={LOW_RISK_SCORE_THRESHOLD}
            highThreshold={HIGH_RISK_SCORE_THRESHOLD}
            isEmbedded={isEmbedded}
          />
        )}
        {isEmbedded && (
          <div className={style.alertPanel}>
            <StyledControlWithLabel label="Alert ID">
              {alertId}
            </StyledControlWithLabel>
            <StyledControlWithLabel label="Alert Reason">
              {ALERT_REASON[data?.alertSourceId] || '-'}
            </StyledControlWithLabel>
            <StyledControlWithLabel label="Alert Date">
              {data?.alertDate ? convertISOToDateFormat(data?.alertDate) : '-'}
            </StyledControlWithLabel>
            <div className={style.alertType}>{alertMetaPrefix}</div>
            {alertMetaSuffix}
          </div>
        )}
      </div>
    </div>
  );
};

const StyledControlWithLabel = styled(ControlWithLabel)`
  padding-right: 48px;
  font-size: 12px;
  font-weight: 700;
`;

/**
 * propTypes
 * @type {{scoreObject: shim}}
 */
CRSDetailHeader.propTypes = {
  customerProfileData: PropTypes.object,
  isEmbedded: PropTypes.bool,
  alertId: PropTypes.string,
  alertMetaSuffix: PropTypes.element,
  alertMetaPrefix: PropTypes.element,
  alertDetails: PropTypes.object
};

/**
 * defaultProps
 * @type {{scoreObject: {}}}
 */
CRSDetailHeader.defaultProps = {
  customerProfileData: {}
};

export default CRSDetailHeader;
